import { Cursor } from 'motion-plus/react';
import { useEffect, useState } from 'react';

import { ThemeModeConstants } from '@helpers/theme.helper';
import { useTheme } from '@providers/themeProvider';

export default function CursorDefaultSettings() {
  const { theme } = useTheme();
  const [isThemeDark, setIsThemeDark] = useState(false);

  useEffect(() => {
    if (theme === ThemeModeConstants.SYSTEM) {
      const systemTheme = window.matchMedia('(prefers-color-scheme: dark)')
        .matches
        ? ThemeModeConstants.DARK
        : ThemeModeConstants.LIGHT;
      setIsThemeDark(systemTheme === ThemeModeConstants.DARK);
      return;
    }
    setIsThemeDark(theme === ThemeModeConstants.DARK);
  }, [theme]);

  return (
    <Cursor
      style={isThemeDark ? cursorDark : cursorLight}
      variants={{
        text: { backgroundColor: '#ff0088' },
        pointer: { backgroundColor: '#ffb537cc' },
        pressed: { backgroundColor: '#ffb537' },
      }}
    />
  );
}

const cursorDark: React.CSSProperties = {
  backgroundColor: '#f5f5f5',
};
const cursorLight: React.CSSProperties = {
  backgroundColor: '#13131366',
};
